import { useTranslation } from 'react-i18next';

import { BlockingReasonRow } from './BlockingReasonRow';

export function RequiredFormReason() {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={t('blockingReasons.formsRequired.title')}
      message={t('blockingReasons.formsRequired.message')}
    />
  );
}
